import axios from 'axios'

export const actions = {
  getVehicles(store, params) {
    const {
      pageSize = 10,
      page = 1,
      sorts = null,
      filters = null,
      additionalQueries = null,
    } = params

    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    if (additionalQueries) {
      query += `&${additionalQueries}`
    }
    query = encodeURI(query)
    const url = `/tables/vehicles?${query}`
    return axios.get(url)
  },
  getVehicleTypes(store, params) {
    const { pageSize = 10, page = 1, sorts = null, filters = null } = params
    let query = `page=${page}&pageSize=${pageSize}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)
    const url = `/tables/vehicleTypes?${query}` // localhost and http. Refer to uri_map
    return axios.get(url)
  },
  getAllVehiclesForCompany(store, params) {
    const { pageSize = -1, page = 1, sorts = null, filters = null } = params

    let query = `page=${page}&pageSize=${pageSize}&referredCompanyId=${params.companyId}`
    if (sorts) {
      query += `&${sorts}`
    }
    if (filters) {
      query += `&${filters}`
    }
    query = encodeURI(query)
    const url = `/tables/vehicles?${query}`
    return axios.get(url)
  },
  getVehicle(store, vehicleId) {
    const url = `/vehicles/${vehicleId}`
    return axios.get(url)
  },
  modifyVehicle(store, params) {
    const url = `/vehicles/${params.id}`

    return axios.put(url, params.payload)
  },
  addVehicle(store, params) {
    const url = `/vehicles`

    return axios.post(url, params.payload)
  },
  uploadVehiclePhotos(store, params) {
    const url = `/vehicles/${params.vehicleId}/vehiclePhotos`
    return axios.post(url, params.payload)
  },
  removeVehiclePhotos(store, params) {
    const url = `/vehicles/${params.vehicleId}/removeVehiclePhotos`
    return axios.post(url, params.payload)
  },
  uploadVehiclePhotosCharterUp(store, params) {
    let url = `/vehicles/${params.companyId}/vehiclePhotosCharterUp`
    return axios.post(url, params.payload)
  },
  getAffiliateSummaryVehicles(store, companyId) {
    let url = `/vehicles/${companyId}/getSummaryVehicles`
    return axios.get(url)
  },
  getAffiliatesVehicleDetails(store, vehicleId) {
    let url = `/vehicles/${vehicleId}/affiliatesDetail`
    return axios.get(url)
  },
  getGaragesByVehicleIds(store, payload) {
    let url = `/vehicles/garages`
    return axios.post(url, payload)
  },
}
